export const formatLicencePlate = (licencePlate: string) => {
    if (!licencePlate) return ''

    // @ts-ignore
    return licencePlate
        .replace(/(\d{2})(\d{2})/g, '$1-$2')
        .replace(/([a-zA-Z]{2})([a-zA-Z]{2})/g, '$1-$2')
        .match(/[a-zA-Z]+|\d+/g)
        .join('-')
}
